import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 'trails',
      label: 'Explore Trails',
      description: 'Discover thematic heritage trails',
      icon: 'Route',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      hoverColor: 'hover:bg-primary/20',
      onClick: () => navigate('/thematic-trails-overview')
    },
    {
      id: 'tourism',
      label: 'Tourism Offerings',
      description: 'Find local accommodations & services',
      icon: 'Building',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      hoverColor: 'hover:bg-accent/20',
      onClick: () => navigate('/tourism-offerings')
    },
    {
      id: 'about',
      label: 'About Project',
      description: 'Learn about Creative Twinning',
      icon: 'Info',
      color: 'text-success',
      bgColor: 'bg-success/10',
      hoverColor: 'hover:bg-success/20',
      onClick: () => navigate('/about-project')
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-card p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Zap" size={20} className="text-primary" />
        <h3 className="font-heading font-semibold text-base text-foreground">
          Quick Actions
        </h3>
      </div>
      <div className="space-y-2">
        {actions?.map((action) => (
          <Button
            key={action?.id}
            variant="ghost"
            onClick={action?.onClick}
            className={`w-full justify-start p-3 h-auto ${action?.hoverColor} transition-colors duration-fast`}
          >
            <div className="flex items-center gap-3 w-full">
              <div className={`p-2 rounded-lg ${action?.bgColor}`}>
                <Icon name={action?.icon} size={16} className={action?.color} />
              </div>
              <div className="flex-1 text-left">
                <p className="font-medium text-sm text-foreground">{action?.label}</p>
                <p className="text-xs text-muted-foreground">{action?.description}</p>
              </div>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
            </div>
          </Button>
        ))}
      </div>
      {/* Additional Info */}
      <div className="mt-4 pt-3 border-t border-border">
        <div className="flex items-start gap-2">
          <Icon name="Lightbulb" size={16} className="text-warning mt-0.5" />
          <div>
            <p className="text-xs font-medium text-foreground mb-1">Pro Tip</p>
            <p className="text-xs text-muted-foreground leading-relaxed">
              Click on map markers to view detailed information about each heritage site, including photos and historical context.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;